import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { FileAnswers, Survey, SurveyService } from '../services/survey.service';
import { SurveyQuestionComponent } from '../survey-question/survey-question.component';
import { FileListComponent } from '../file-list/file-list.component';
import { countries } from '../countries';

const DefaultFileAnswers: Readonly<FileAnswers> = {
    beforeDeath: '',
    audience: [],
    country: '',
    language: '',
    format: '',
    formatDetails: '',
    furtherInformation: ''
};

@Component({
    selector: 'ell-survey-file',
    standalone: true,
    imports: [SurveyQuestionComponent, FileListComponent, RouterLink, FormsModule],
    templateUrl: './survey-file.component.html',
    styleUrl: './survey-file.component.scss'
})
export class SurveyFileComponent {
    error = '';

    page = 1;

    answers: FileAnswers = {
        ...DefaultFileAnswers
    };

    audienceOptions = [
        $localize`Their partner`,
        $localize`Their child/children`,
        $localize`Other relatives`,
        $localize`Friends`,
        $localize`Police`,
        $localize`Medical professionals`,
        $localize`Whoever found them`,
        $localize`Other (please give information)`
    ];

    formatOptions = [
        $localize`handwritten`,
        $localize`typed`,
        $localize`printed via computer`,
        $localize`electronic form - email`,
        $localize`electronic form - social media (e.g. Facebook, Twitter) (please give details below)`,
        $localize`other (please give details below)`
    ];

    countryOptions = [
        ...countries,
        $localize`Other`
    ];

    // last two format options
    openFormatOptions = new Set([
        this.formatOptions.length - 2,
        this.formatOptions.length - 1
    ].map(i => this.formatOptions[i]));

    /**
     * The file asked to describe
     */
    @Input()
    file?: File;

    @Input()
    survey?: Survey;

    @Output()
    complete = new EventEmitter<FileAnswers>();

    @ViewChildren(SurveyQuestionComponent)
    questions!: QueryList<SurveyQuestionComponent<any>>;

    constructor(private surveyService: SurveyService) {
    }

    next() {
        this.complete.emit(this.answers);
        // reset for the next file
        this.answers = {
            ...DefaultFileAnswers,
            audience: [] // also reset this list
        };
    }

    ngAfterViewChecked(): void {
        if (this.survey) {
            this.surveyService.registerQuestions(this.survey, this.questions);
        }
    }
}
